import React from "react";

/**
 * Full-screen "access restricted" gate, shown when the site-hit beacon reports
 * the visitor's IP/region is on the security blocklist. Renders in place of the
 * app. Intentionally minimal and self-contained (no app chrome, no data calls).
 *
 * This is an app-layer block only — it stops SPA usage, not raw requests to
 * static assets at the CDN edge.
 */
export default function BlockScreen() {
  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "24px",
        background: "#0b1220",
        color: "#e5e7eb",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      }}
    >
      <div style={{ maxWidth: 520 }}>
        <h1 style={{ fontSize: "1.6rem", marginBottom: "12px" }}>Access restricted</h1>
        <p style={{ lineHeight: 1.6, color: "#9ca3af" }}>
          Access to the USVI Pirate&rsquo;s Guild has been restricted from your
          network. If you believe this is a mistake, contact{" "}
          <a href="mailto:info@usvipiratesguild.com" style={{ color: "#93c5fd" }}>
            info@usvipiratesguild.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
